import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import D2DSaleForm from './D2DSaleForm';
import FieldSalesMap from './FieldSalesMap';
import KnockReports from './KnockReports';
import ConversationRecordings from './ConversationRecordings';
import SyncStatusPage from './SyncStatusPage';
import CommissionAdmin from './CommissionAdmin';
import AiRevival from './AiRevival';
import PartnerProspects from './PartnerProspects';

export default function SalesRouter() {
  return (
    <Routes>
      <Route path="d2d" element={<D2DSaleForm />} />
      <Route path="map" element={<FieldSalesMap />} />
      <Route path="revival" element={<AiRevival />} />
      <Route path="reports" element={<KnockReports />} />
      <Route path="recordings" element={<ConversationRecordings />} />
      <Route path="sync" element={<SyncStatusPage />} />
      <Route path="commissions" element={<CommissionAdmin />} />
      <Route path="partners" element={<PartnerProspects />} />
      <Route path="*" element={<Navigate to="map" replace />} />
    </Routes>
  );
}
